import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	overflow-y: auto;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		height: 60%;
	}
`;

export const Content = styled.div`
	width: 50%;
	height: 100%;
	background: #23242f;
	z-index: 1000;
	padding: 1rem 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: "MetropolisRegular";

	@media only screen and (max-width: 900px) {
		background: #13141b;
		position: relative;
		width: 23rem;
		justify-content: flex-start;
		padding: 0;
		height: 90%;
	}
`;

export const Wrapper = styled.div`
	width: 27rem;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;

	@media only screen and (max-width: 900px) {
		width: 21.5rem;
		justify-content: space-between;
	}
`;

export const ContainerButton = styled.div`
	width: 27rem;
	height: 6rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: 2.5rem;

	@media only screen and (max-width: 900px) {
		width: 21.5rem;
	}

	@media only screen and (max-width: 380) {
		width: 20.5rem;
	}
`;

export const Title = styled.span`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
	padding-bottom: 0.5rem;
`;

export const Subtitle = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: var(--font-family-metropolis-regular);

	@media only screen and (max-width: 900px) {
		display: none;
	}
`;

export const SubtitleMobile = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: var(--font-family-metropolis-regular);
	display: none;

	@media only screen and (max-width: 900px) {
		display: contents;
	}
`;
